<template>
  <div>
    <div class="table-container mb-6 mt-0">
        <table class="dep-table details-table mt-5" style="width: 100%; border-collapse: collapse;">
            <thead>
                <tr>
                    <th class="text-center" style="width: 40px; border: 1px solid #000; padding: 2px; font-size: 12px;">SL</th>
                    <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Product Name</th>
                    <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Product Code</th>
                    <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Unit</th>
                    <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Quantity</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(detail, index) in purchaseRequisitionData?.requisition_details"
                    :key="detail.id">
                    <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ index + 1 }}</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ detail.product?.name }}</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ detail.product?.code }}</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ detail.product?.unit?.name }}</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-size: 12px;">{{ detail?.qty }}</td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "purchaseRequisitionDetailsTable",
  data() {
    return {
      purchaseRequisitionData: null,
    };
  },
  
  computed: {},
  watch: {},
  created() {},
  methods: {
  },
  setup(props, { emit }) { },
  
  mounted() {
    const id = this.$route.query.referenceable_id;

    this.$store.dispatch('getPurRequisitionById', id)
      .then((res) => {
        this.purchaseRequisitionData = res;
      })

  },
};  

</script>

<style scoped>
.table-container {
  width: 100%;
}

.dep-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.dep-table th,
.dep-table td {
  border: 1px solid #000;
  padding: 6px;
}

.dep-table th {
  background: #e0e0e0;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}
</style>
